import {
  SwapHoriz as CarsInNegotiationIcon,
  FlashOn as LiveActionIcon,
  Garage as MyGarageIcon,
  DirectionsCar as SellMyCarIcon,
  Update as UpcomingCarsIcon,
  WatchLater as WatchListIcon,
} from "@mui/icons-material";
import { routes } from "./routes";

export const SidebarOptions = [
  {
    label: "Dashboard",
    value: "dashboard",
    icon: <SellMyCarIcon />,
    navigationRoute: ""
  },
  {
    label: "My Garage",
    value: "myGarage",
    icon: <MyGarageIcon />,
    navigationRoute: routes.myGarage
  },
  {
    label: "Upcoming Cars",
    value: "upcomingCars",
    icon: <UpcomingCarsIcon />,
    navigationRoute: routes.upcomingCars
  },
  {
    label: "Buy Now",
    value: "buyNow",
    icon: <LiveActionIcon />,
    navigationRoute: routes.buyNow
  },
  {
    label: "Live Auction",
    value: "liveAuction",
    icon: <LiveActionIcon />,
    navigationRoute: routes.liveAuction
  },
  {
    label: "Negotiation Live Auction",
    value: "carsInNegotiation",
    icon: <CarsInNegotiationIcon />,
    navigationRoute: routes.carsInNegotiation,
    group: "negotiation",
    groupLabel: "Negotiation"
  },
  {
    label: "Negotiation Buy Now",
    value: "carsInNegotiationBuyNow",
    navigationRoute: routes.carsInNegotiationBuyNow,
    group: "negotiation",
    groupLabel: "Negotiation"
    // icon: <CarsInNegotiationIcon />,
  },
  {
    label: "Watch List",
    value: "watchList",
    icon: <CarsInNegotiationIcon />,
    navigationRoute: routes.watchList
  },
  {
    label: "My Orders",
    value: "myOrders",
    icon: <CarsInNegotiationIcon />,
    navigationRoute: routes.myOrders
  },
  {
    label: "Profile",
    value: "profile",
    icon: <CarsInNegotiationIcon />,
    navigationRoute: routes.profile
  },
  {
    label: "Car Estimate",
    value: "carEstimate",
    icon: <CarsInNegotiationIcon />,
    dontShow: true,
    navigationRoute: routes.carEstimate
  },
];
